<app-header-profile (on-close-session)="onCloseSession($event)"></app-header-profile>
<div class="app-router-container">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
<app-close-session-modal (on-confirm)="onConfirmCloseSession($event)"></app-close-session-modal>